var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 97,
    viewBox: "0 0 213 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00022 1.64C0.00022 0.73425 0.73447 0 1.64022 0C2.54597 0 3.28022 0.73425 3.28022 1.64C3.28022 2.54575 2.54597 3.28 1.64022 3.28C0.73447 3.28 0.00022 2.54575 0.00022 1.64Z",
    fill: "#59C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2788 1.64C23.2788 0.73425 24.0131 0 24.9188 0C25.8246 0 26.5588 0.73425 26.5588 1.64C26.5588 2.54575 25.8246 3.28 24.9188 3.28C24.0131 3.28 23.2788 2.54575 23.2788 1.64Z",
    fill: "#59C3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5613 1.64C46.5613 0.73425 47.2956 0 48.2013 0C49.1071 0 49.8413 0.73425 49.8413 1.64C49.8413 2.54575 49.1071 3.28 48.2013 3.28C47.2956 3.28 46.5613 2.54575 46.5613 1.64Z",
    fill: "#59C3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8399 1.64C69.8399 0.73425 70.5742 0 71.4799 0C72.3857 0 73.1199 0.73425 73.1199 1.64C73.1199 2.54575 72.3857 3.28 71.4799 3.28C70.5742 3.28 69.8399 2.54575 69.8399 1.64Z",
    fill: "#59C3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1185 1.64C93.1185 0.73425 93.8528 0 94.7585 0C95.6643 0 96.3985 0.73425 96.3985 1.64C96.3985 2.54575 95.6643 3.28 94.7585 3.28C93.8528 3.28 93.1185 2.54575 93.1185 1.64Z",
    fill: "#59C3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.401 1.64C116.401 0.73425 117.135 0 118.041 0C118.947 0 119.681 0.73425 119.681 1.64C119.681 2.54575 118.947 3.28 118.041 3.28C117.135 3.28 116.401 2.54575 116.401 1.64Z",
    fill: "#59C3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.68 1.64C139.68 0.73425 140.414 0 141.32 0C142.225 0 142.96 0.73425 142.96 1.64C142.96 2.54575 142.225 3.28 141.32 3.28C140.414 3.28 139.68 2.54575 139.68 1.64Z",
    fill: "#59C3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.962 1.64C162.962 0.73425 163.696 0 164.602 0C165.508 0 166.242 0.73425 166.242 1.64C166.242 2.54575 165.508 3.28 164.602 3.28C163.696 3.28 162.962 2.54575 162.962 1.64Z",
    fill: "#59C3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.241 1.64C186.241 0.73425 186.975 0 187.881 0C188.786 0 189.521 0.73425 189.521 1.64C189.521 2.54575 188.786 3.28 187.881 3.28C186.975 3.28 186.241 2.54575 186.241 1.64Z",
    fill: "#59C3FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.519 1.64C209.519 0.73425 210.254 0 211.159 0C212.065 0 212.799 0.73425 212.799 1.64C212.799 2.54575 212.065 3.28 211.159 3.28C210.254 3.28 209.519 2.54575 209.519 1.64Z",
    fill: "#59C3FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00022 24.9201C0.00022 24.0143 0.73447 23.2801 1.64022 23.2801C2.54597 23.2801 3.28022 24.0143 3.28022 24.9201C3.28022 25.8258 2.54597 26.5601 1.64022 26.5601C0.73447 26.5601 0.00022 25.8258 0.00022 24.9201Z",
    fill: "#59C3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2788 24.9201C23.2788 24.0143 24.0131 23.2801 24.9188 23.2801C25.8246 23.2801 26.5588 24.0143 26.5588 24.9201C26.5588 25.8258 25.8246 26.5601 24.9188 26.5601C24.0131 26.5601 23.2788 25.8258 23.2788 24.9201Z",
    fill: "#59C3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5613 24.9201C46.5613 24.0143 47.2956 23.2801 48.2013 23.2801C49.1071 23.2801 49.8413 24.0143 49.8413 24.9201C49.8413 25.8258 49.1071 26.5601 48.2013 26.5601C47.2956 26.5601 46.5613 25.8258 46.5613 24.9201Z",
    fill: "#59C3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8399 24.9201C69.8399 24.0143 70.5742 23.2801 71.4799 23.2801C72.3857 23.2801 73.1199 24.0143 73.1199 24.9201C73.1199 25.8258 72.3857 26.5601 71.4799 26.5601C70.5742 26.5601 69.8399 25.8258 69.8399 24.9201Z",
    fill: "#59C3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1185 24.9201C93.1185 24.0143 93.8528 23.2801 94.7585 23.2801C95.6643 23.2801 96.3985 24.0143 96.3985 24.9201C96.3985 25.8258 95.6643 26.5601 94.7585 26.5601C93.8528 26.5601 93.1185 25.8258 93.1185 24.9201Z",
    fill: "#59C3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.401 24.9201C116.401 24.0143 117.135 23.2801 118.041 23.2801C118.947 23.2801 119.681 24.0143 119.681 24.9201C119.681 25.8258 118.947 26.5601 118.041 26.5601C117.135 26.5601 116.401 25.8258 116.401 24.9201Z",
    fill: "#59C3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.68 24.9201C139.68 24.0143 140.414 23.2801 141.32 23.2801C142.225 23.2801 142.96 24.0143 142.96 24.9201C142.96 25.8258 142.225 26.5601 141.32 26.5601C140.414 26.5601 139.68 25.8258 139.68 24.9201Z",
    fill: "#59C3FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.962 24.9201C162.962 24.0143 163.696 23.2801 164.602 23.2801C165.508 23.2801 166.242 24.0143 166.242 24.9201C166.242 25.8258 165.508 26.5601 164.602 26.5601C163.696 26.5601 162.962 25.8258 162.962 24.9201Z",
    fill: "#59C3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.241 24.9201C186.241 24.0143 186.975 23.2801 187.881 23.2801C188.786 23.2801 189.521 24.0143 189.521 24.9201C189.521 25.8258 188.786 26.5601 187.881 26.5601C186.975 26.5601 186.241 25.8258 186.241 24.9201Z",
    fill: "#59C3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.519 24.9201C209.519 24.0143 210.254 23.2801 211.159 23.2801C212.065 23.2801 212.799 24.0143 212.799 24.9201C212.799 25.8258 212.065 26.5601 211.159 26.5601C210.254 26.5601 209.519 25.8258 209.519 24.9201Z",
    fill: "#59C3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00022 48.2001C0.00022 47.2944 0.73447 46.5601 1.64022 46.5601C2.54597 46.5601 3.28022 47.2944 3.28022 48.2001C3.28022 49.1059 2.54597 49.8401 1.64022 49.8401C0.73447 49.8401 0.00022 49.1059 0.00022 48.2001Z",
    fill: "#59C3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2788 48.2001C23.2788 47.2944 24.0131 46.5601 24.9188 46.5601C25.8246 46.5601 26.5588 47.2944 26.5588 48.2001C26.5588 49.1059 25.8246 49.8401 24.9188 49.8401C24.0131 49.8401 23.2788 49.1059 23.2788 48.2001Z",
    fill: "#59C3FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5613 48.2001C46.5613 47.2944 47.2956 46.5601 48.2013 46.5601C49.1071 46.5601 49.8413 47.2944 49.8413 48.2001C49.8413 49.1059 49.1071 49.8401 48.2013 49.8401C47.2956 49.8401 46.5613 49.1059 46.5613 48.2001Z",
    fill: "#59C3FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8399 48.2001C69.8399 47.2944 70.5742 46.5601 71.4799 46.5601C72.3857 46.5601 73.1199 47.2944 73.1199 48.2001C73.1199 49.1059 72.3857 49.8401 71.4799 49.8401C70.5742 49.8401 69.8399 49.1059 69.8399 48.2001Z",
    fill: "#59C3FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1185 48.2001C93.1185 47.2944 93.8528 46.5601 94.7585 46.5601C95.6643 46.5601 96.3985 47.2944 96.3985 48.2001C96.3985 49.1059 95.6643 49.8401 94.7585 49.8401C93.8528 49.8401 93.1185 49.1059 93.1185 48.2001Z",
    fill: "#59C3FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.401 48.2001C116.401 47.2944 117.135 46.5601 118.041 46.5601C118.947 46.5601 119.681 47.2944 119.681 48.2001C119.681 49.1059 118.947 49.8401 118.041 49.8401C117.135 49.8401 116.401 49.1059 116.401 48.2001Z",
    fill: "#59C3FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.68 48.2001C139.68 47.2944 140.414 46.5601 141.32 46.5601C142.225 46.5601 142.96 47.2944 142.96 48.2001C142.96 49.1059 142.225 49.8401 141.32 49.8401C140.414 49.8401 139.68 49.1059 139.68 48.2001Z",
    fill: "#59C3FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.962 48.2001C162.962 47.2944 163.696 46.5601 164.602 46.5601C165.508 46.5601 166.242 47.2944 166.242 48.2001C166.242 49.1059 165.508 49.8401 164.602 49.8401C163.696 49.8401 162.962 49.1059 162.962 48.2001Z",
    fill: "#59C3FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.241 48.2001C186.241 47.2944 186.975 46.5601 187.881 46.5601C188.786 46.5601 189.521 47.2944 189.521 48.2001C189.521 49.1059 188.786 49.8401 187.881 49.8401C186.975 49.8401 186.241 49.1059 186.241 48.2001Z",
    fill: "#59C3FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.519 48.2001C209.519 47.2944 210.254 46.5601 211.159 46.5601C212.065 46.5601 212.799 47.2944 212.799 48.2001C212.799 49.1059 212.065 49.8401 211.159 49.8401C210.254 49.8401 209.519 49.1059 209.519 48.2001Z",
    fill: "#59C3FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00022 71.4799C0.00022 70.5742 0.73447 69.8399 1.64022 69.8399C2.54597 69.8399 3.28022 70.5742 3.28022 71.4799C3.28022 72.3857 2.54597 73.1199 1.64022 73.1199C0.73447 73.1199 0.00022 72.3857 0.00022 71.4799Z",
    fill: "#59C3FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2788 71.4799C23.2788 70.5742 24.0131 69.8399 24.9188 69.8399C25.8246 69.8399 26.5588 70.5742 26.5588 71.4799C26.5588 72.3857 25.8246 73.1199 24.9188 73.1199C24.0131 73.1199 23.2788 72.3857 23.2788 71.4799Z",
    fill: "#59C3FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5613 71.4799C46.5613 70.5742 47.2956 69.8399 48.2013 69.8399C49.1071 69.8399 49.8413 70.5742 49.8413 71.4799C49.8413 72.3857 49.1071 73.1199 48.2013 73.1199C47.2956 73.1199 46.5613 72.3857 46.5613 71.4799Z",
    fill: "#59C3FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8399 71.4799C69.8399 70.5742 70.5742 69.8399 71.4799 69.8399C72.3857 69.8399 73.1199 70.5742 73.1199 71.4799C73.1199 72.3857 72.3857 73.1199 71.4799 73.1199C70.5742 73.1199 69.8399 72.3857 69.8399 71.4799Z",
    fill: "#59C3FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1185 71.4799C93.1185 70.5742 93.8528 69.8399 94.7585 69.8399C95.6643 69.8399 96.3985 70.5742 96.3985 71.4799C96.3985 72.3857 95.6643 73.1199 94.7585 73.1199C93.8528 73.1199 93.1185 72.3857 93.1185 71.4799Z",
    fill: "#59C3FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.401 71.4799C116.401 70.5742 117.135 69.8399 118.041 69.8399C118.947 69.8399 119.681 70.5742 119.681 71.4799C119.681 72.3857 118.947 73.1199 118.041 73.1199C117.135 73.1199 116.401 72.3857 116.401 71.4799Z",
    fill: "#59C3FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.68 71.4799C139.68 70.5742 140.414 69.8399 141.32 69.8399C142.225 69.8399 142.96 70.5742 142.96 71.4799C142.96 72.3857 142.225 73.1199 141.32 73.1199C140.414 73.1199 139.68 72.3857 139.68 71.4799Z",
    fill: "#59C3FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.962 71.4799C162.962 70.5742 163.696 69.8399 164.602 69.8399C165.508 69.8399 166.242 70.5742 166.242 71.4799C166.242 72.3857 165.508 73.1199 164.602 73.1199C163.696 73.1199 162.962 72.3857 162.962 71.4799Z",
    fill: "#59C3FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.241 71.4799C186.241 70.5742 186.975 69.8399 187.881 69.8399C188.786 69.8399 189.521 70.5742 189.521 71.4799C189.521 72.3857 188.786 73.1199 187.881 73.1199C186.975 73.1199 186.241 72.3857 186.241 71.4799Z",
    fill: "#59C3FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.519 71.4799C209.519 70.5742 210.254 69.8399 211.159 69.8399C212.065 69.8399 212.799 70.5742 212.799 71.4799C212.799 72.3857 212.065 73.1199 211.159 73.1199C210.254 73.1199 209.519 72.3857 209.519 71.4799Z",
    fill: "#59C3FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00022 94.76C0.00022 93.8542 0.73447 93.12 1.64022 93.12C2.54597 93.12 3.28022 93.8542 3.28022 94.76C3.28022 95.6657 2.54597 96.4 1.64022 96.4C0.73447 96.4 0.00022 95.6657 0.00022 94.76Z",
    fill: "#59C3FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2788 94.76C23.2788 93.8542 24.0131 93.12 24.9188 93.12C25.8246 93.12 26.5588 93.8542 26.5588 94.76C26.5588 95.6657 25.8246 96.4 24.9188 96.4C24.0131 96.4 23.2788 95.6657 23.2788 94.76Z",
    fill: "#59C3FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5613 94.76C46.5613 93.8542 47.2956 93.12 48.2013 93.12C49.1071 93.12 49.8413 93.8542 49.8413 94.76C49.8413 95.6657 49.1071 96.4 48.2013 96.4C47.2956 96.4 46.5613 95.6657 46.5613 94.76Z",
    fill: "#59C3FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8399 94.76C69.8399 93.8542 70.5742 93.12 71.4799 93.12C72.3857 93.12 73.1199 93.8542 73.1199 94.76C73.1199 95.6657 72.3857 96.4 71.4799 96.4C70.5742 96.4 69.8399 95.6657 69.8399 94.76Z",
    fill: "#59C3FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1185 94.76C93.1185 93.8542 93.8528 93.12 94.7585 93.12C95.6643 93.12 96.3985 93.8542 96.3985 94.76C96.3985 95.6657 95.6643 96.4 94.7585 96.4C93.8528 96.4 93.1185 95.6657 93.1185 94.76Z",
    fill: "#59C3FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.401 94.76C116.401 93.8542 117.135 93.12 118.041 93.12C118.947 93.12 119.681 93.8542 119.681 94.76C119.681 95.6657 118.947 96.4 118.041 96.4C117.135 96.4 116.401 95.6657 116.401 94.76Z",
    fill: "#59C3FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.68 94.76C139.68 93.8542 140.414 93.12 141.32 93.12C142.225 93.12 142.96 93.8542 142.96 94.76C142.96 95.6657 142.225 96.4 141.32 96.4C140.414 96.4 139.68 95.6657 139.68 94.76Z",
    fill: "#59C3FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.962 94.76C162.962 93.8542 163.696 93.12 164.602 93.12C165.508 93.12 166.242 93.8542 166.242 94.76C166.242 95.6657 165.508 96.4 164.602 96.4C163.696 96.4 162.962 95.6657 162.962 94.76Z",
    fill: "#59C3FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.241 94.76C186.241 93.8542 186.975 93.12 187.881 93.12C188.786 93.12 189.521 93.8542 189.521 94.76C189.521 95.6657 188.786 96.4 187.881 96.4C186.975 96.4 186.241 95.6657 186.241 94.76Z",
    fill: "#59C3FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.519 94.76C209.519 93.8542 210.254 93.12 211.159 93.12C212.065 93.12 212.799 93.8542 212.799 94.76C212.799 95.6657 212.065 96.4 211.159 96.4C210.254 96.4 209.519 95.6657 209.519 94.76Z",
    fill: "#59C3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDots);
export default __webpack_public_path__ + "static/media/Background-dots.c39ef698cf4b14f86e00226c0ea763f5.svg";
export { ForwardRef as ReactComponent };